export const TOPBAR_HEIGHT = 48; // Height of the topbar in pixels
